import styled from 'styled-components'

export const DocumentationWrapper = styled.div`
  position: relative;
`
